//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import type { AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

import { throwException, isAxiosError } from '../api-client.types';
import { getAxios, getBaseUrl } from './helpers';

export function deleteTenant(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/tenant";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigDeleteTenant,
        ...config,
        method: "DELETE",
        url: url_,
        headers: {
            ..._requestConfigDeleteTenant?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDeleteTenant(_response);
    });
}

function processDeleteTenant(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function resetTenant(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/tenant/reset";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetTenant,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetTenant?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetTenant(_response);
    });
}

function processResetTenant(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function resetPatients(config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/tenant/reset-patients";
      url_ = url_.replace(/[?&]$/, "");

    let options_: AxiosRequestConfig = {
        ..._requestConfigResetPatients,
        ...config,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigResetPatients?.headers,
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processResetPatients(_response);
    });
}

function processResetPatients(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}

export function dateTimeSerialization(dto: Types.DateTimeSerializationDto, config?: AxiosRequestConfig | undefined): Promise<Types.DateTimeSerializationDto> {
    let url_ = getBaseUrl() + "/api/test/datetime-serialization";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeDateTimeSerializationDto(dto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigDateTimeSerialization,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigDateTimeSerialization?.headers,
            "Content-Type": "application/json",
            "Accept": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processDateTimeSerialization(_response);
    });
}

function processDateTimeSerialization(response: AxiosResponse): Promise<Types.DateTimeSerializationDto> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        let result200: any = null;
        let resultData200  = _responseText;
        result200 = Types.initDateTimeSerializationDto(resultData200);
        return Promise.resolve<Types.DateTimeSerializationDto>(result200);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<Types.DateTimeSerializationDto>(null as any);
}

/**
 * This method exists so that SignalR types are generated on the frontend and could be used when
parsing SignalR messages
 */
export function signalRClientDeclarations(notificationDto: Types.NotificationDto, config?: AxiosRequestConfig | undefined): Promise<void> {
    let url_ = getBaseUrl() + "/api/test/signalr-client-declarations";
      url_ = url_.replace(/[?&]$/, "");

    const content_ = Types.serializeNotificationDto(notificationDto);

    let options_: AxiosRequestConfig = {
        ..._requestConfigSignalRClientDeclarations,
        ...config,
        data: content_,
        method: "POST",
        url: url_,
        headers: {
            ..._requestConfigSignalRClientDeclarations?.headers,
            "Content-Type": "application/json",
            ...config?.headers,
        }
    };

    return getAxios().request(options_).catch((_error: any) => {
        if (isAxiosError(_error) && _error.response) {
            return _error.response;
        } else {
            throw _error;
        }
    }).then((_response: AxiosResponse) => {
        return processSignalRClientDeclarations(_response);
    });
}

function processSignalRClientDeclarations(response: AxiosResponse): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && typeof response.headers === "object") {
        for (let k in response.headers) {
            if (response.headers.hasOwnProperty(k)) {
                _headers[k] = response.headers[k];
            }
        }
    }
    if (status === 400) {
        const _responseText = response.data;
        let result400: any = null;
        let resultData400  = _responseText;
        result400 = Types.initValidationProblemDetails(resultData400);
        return throwException("A server side error occurred.", status, _responseText, _headers, result400);

    } else if (status === 200) {
        const _responseText = response.data;
        return Promise.resolve<void>(null as any);

    } else if (status !== 200 && status !== 204) {
        const _responseText = response.data;
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
    }
    return Promise.resolve<void>(null as any);
}
let _requestConfigDeleteTenant: Partial<AxiosRequestConfig> | null;
export function getDeleteTenantRequestConfig() {
  return _requestConfigDeleteTenant;
}
export function setDeleteTenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDeleteTenant = value;
}
export function patchDeleteTenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDeleteTenant = patch(_requestConfigDeleteTenant ?? {});
}

let _requestConfigResetTenant: Partial<AxiosRequestConfig> | null;
export function getResetTenantRequestConfig() {
  return _requestConfigResetTenant;
}
export function setResetTenantRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetTenant = value;
}
export function patchResetTenantRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetTenant = patch(_requestConfigResetTenant ?? {});
}

let _requestConfigResetPatients: Partial<AxiosRequestConfig> | null;
export function getResetPatientsRequestConfig() {
  return _requestConfigResetPatients;
}
export function setResetPatientsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigResetPatients = value;
}
export function patchResetPatientsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigResetPatients = patch(_requestConfigResetPatients ?? {});
}

let _requestConfigDateTimeSerialization: Partial<AxiosRequestConfig> | null;
export function getDateTimeSerializationRequestConfig() {
  return _requestConfigDateTimeSerialization;
}
export function setDateTimeSerializationRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigDateTimeSerialization = value;
}
export function patchDateTimeSerializationRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigDateTimeSerialization = patch(_requestConfigDateTimeSerialization ?? {});
}

let _requestConfigSignalRClientDeclarations: Partial<AxiosRequestConfig> | null;
export function getSignalRClientDeclarationsRequestConfig() {
  return _requestConfigSignalRClientDeclarations;
}
export function setSignalRClientDeclarationsRequestConfig(value: Partial<AxiosRequestConfig>) {
  _requestConfigSignalRClientDeclarations = value;
}
export function patchSignalRClientDeclarationsRequestConfig(patch: (value: Partial<AxiosRequestConfig>) => Partial<AxiosRequestConfig>) {
  _requestConfigSignalRClientDeclarations = patch(_requestConfigSignalRClientDeclarations ?? {});
}